export default "__VITE_ASSET__BLzEdHAg__"